import { get, post, put, del } from "../libs/https";
const publicPath = process.env.BASE_URL;

// Agreements ----------------------------------------------------------------
export const getAllAgreements = async (type) => {
  return await get(`${publicPath}api/agreements?type=${type}`);
};

// Application ----------------------------------------------------------------
export const getApplication = async (id) => {
  return await get(`${publicPath}api/application/${id}`);
};

export const saveApplication = async (id, json, agID) => {
  return await put(`${publicPath}api/application/${id}` + (agID ? `?da=${agID}` : ''), { json });
};

export const submitApplication = async (id) => {
  return await post(`${publicPath}api/application/${id}`, {});
};

export const saveNewApplication = async (json, agID) => {
  return await post(`${publicPath}api/application` + (agID ? `?da=${agID}` : ''), { json });
};

export const deleteApplication = async (id) => {
  return await del(`${publicPath}api/application/${id}`);
};

export const getAllApplications = async () => {
  return await get(`${publicPath}api/applications`);
};

// Pages ----------------------------------------------------------------
export const getLoanPage = async (id, type, page) => {
  if (page) {
    return await get(`${publicPath}api/pages/${id}/${page}?type=${type}`);
  } else {
    return await get(`${publicPath}api/pages/${id}/?type=${type}`);
  }
};

export const getLoanConditionalPage = async (id, type, page) => {
  return await get(
    `${publicPath}api/pages/${id}/${page}/conditional?type=${type}`
  );
};

export const getAllPages = async (type) => {
  return await get(`${publicPath}api/pages?type=${type}`);
};

// Fields ----------------------------------------------------------------
export const getPageFields = async (page) => {
  return await get(`${publicPath}api/fields?page=${page}`);
};

// Co-Borrowers ----------------------------------------------------------------
export const saveCoBorrowers = async (borrowers, id) => {
  return await post(`${publicPath}api/application/${id}/coBorrowers`, borrowers);
};

export const reInviteCoBorrowers = async (borrower, id) => {
  return await put(`${publicPath}api/application/${id}/coBorrowers`, borrower);
};

export const getAllCoBorrowers = async (id) => {
  return await get(`${publicPath}api/application/${id}/coBorrowers`);
};

export const checkForInvites = async () => {
  return await get(`${publicPath}api/coBorrower/invite`);
};

export const getCoBorrowerProgress = async (id) => {
  return await get(`${publicPath}api/coBorrower/progress/${id}`);
};

export const respondToInvite = async (id, status) => {
  return await post(`${publicPath}api/coBorrower/invite/${id}`,{status});
};

export const deleteCoBorrowers = async (user, id) => {
  return await del(`${publicPath}api/application/${id}/coBorrowers`, user);
};

// Methods ---------------------------------------------------------------
export const applyToApplication = async (array, app) => {
  for (let i = 0; i < array.length; i++) {
    const a = array[i];
    if (a.length) {
      for (let l = 0; l < a.length; l++) {
        const b = a[l];
        if (!b.Disable) {
          app.fields[b.NameID] = b.Value;
        }
      }
    } else {
      if (!a.Disable) {
        if (a.Table) {
          for (let r = 0; r < a.Table.length; r++) {
            a.Table[r] = a.Table[r].flatMap((c) => {
              let t = {};          
              t[c.NameID] = c.Value;
              return t;
            });
          }
          app.fields[a.NameID] = a.Table;
          app.fields = await _applyTableLogic(
            a.Table,
            a.FieldJSON.table.logics,
            app.fields
          );
        } else {
          app.fields[a.NameID] = a.Value;
        }
      }
    }
  }
  return app;
};

const _applyTableLogic = async (table, logics, fields) => {
  for (let i = 0; i < logics.length; i++) {
    const logic = logics[i];

    if (logic.method == "sum") {
      let columnSum = [];
      if (logic.columns == "all") {
        if (logic.rows == "all") {
          for (let r = 0; r < table.length; r++) {
            const row = table[r];
            for (let c = 0; c < row.length; c++) {
              const column = row[c];
              let res = await _keyAndClean(column);
              if (res.value  && !isNaN(res.value)) {
                columnSum.push(parseFloat(res.value));
              }
            }
          }
          fields[logic.methodNameID] = parseFloat(columnSum.reduce((f, n) => f + n)).toFixed(2);
        } else {
          for (let sr = 0; sr < logic.rows.length; sr++) {
            const index = logic.rows[sr];
            for (let c = 0; c < table[index].length; c++) {
              const column = table[index][c];
              let res = await _keyAndClean(column);
              if (res.value && !isNaN(res.value)) {
                columnSum.push(parseFloat(res.value));
              }
            }
          }
          fields[logic.methodNameID] = parseFloat(columnSum.reduce((f, n) => f + n)).toFixed(2);
        }
      } else {
        for (let sc = 0; sc < logic.columns.length; sc++) {
          const colName = logic.columns[sc];
          if (logic.rows == "all") {
            for (let r = 0; r < table.length; r++) {
              const row = table[r];
              for (let c = 0; c < row.length; c++) {
                const column = row[c];
                let key = Object.keys(column);
                if (key[0] === colName) {
                  let res = await _keyAndClean(column);
                  if (!isNaN(res.value)) {
                    columnSum.push(parseFloat(res.value));
                  }
                }
              }
            }
            fields[logic.methodNameID] = parseFloat(columnSum.reduce((f, n) => f + n)).toFixed(2);
          } else {
            for (let sr = 0; sr < logic.rows.length; sr++) {
              const index = logic.rows[sr];
              for (let c = 0; c < table[index].length; c++) {
                const column = table[index][c];
                let key = Object.keys(column);
                if (key[0] === colName) {
                  let res = await _keyAndClean(column);
                  if (!isNaN(res.value)) {
                    columnSum.push(parseFloat(res.value));
                  }
                }
              }
            }
            fields[logic.methodNameID] = parseFloat(columnSum.reduce((f, n) => f + n)).toFixed(2);
          }
        }
      }
    }
  }
  return fields;
};


const _keyAndClean = async (c) => {
  let key = Object.keys(c);
  let val = c[key[0]];
  if (typeof val == "string") {
    val = val.replaceAll("$ ", "");
    val = val.replaceAll(",", "");
    val = val.replaceAll(" ", "");
  }
  return { key: key[0], value: parseFloat(val).toFixed(2) };
};

export const applyToFields = async (array, app) => {
  for (let i = 0; i < array.length; i++) {
    const a = array[i];

    if (a.length) {
      for (let l = 0; l < a.length; l++) {
        const b = a[l];
        if (app.fields[b.NameID]) {
          b.Value = app.fields[b.NameID];
        }
      }
    } else {
      if (app.fields[a.NameID]) {
        if (typeof app.fields[a.NameID] === 'object') {
          for (let r = 0; r < app.fields[a.NameID].length; r++) {
            const row = app.fields[a.NameID][r];
            for (let c = 0; c < row.length; c++) {
              const column = row[c];
              let res;
              if (!a.Table[r]) {
                a.Table.push(JSON.parse(JSON.stringify(a.Template)))
              }
              if (!a.Table[r][c]) {
                continue
              }
              if (a.Table[r][c].FieldTypeID === 6) {
                res = await _keyAndClean(column);
              } else {
                let key = Object.keys(column);
                res = {key: key[0], value: column[key[0]]}
                res.value = res.value === 'NaN' ? '' : res.value;
              }
               
              if (a.Table && a.Table.length) {
                if (a.Table[r]) {
                  if (a.Table[r][c].FieldTypeID === 6) {
                    a.Table[r][c].Value = res.value;
                  } else {
                    a.Table[r][c].Value = res.value;
                  }
                } else {
                  a.Table.push(a.Template);
                  if (a.Table[r][c].FieldTypeID === 6) {
                    a.Table[r][c].Value = res.value;
                  } else {
                    a.Table[r][c].Value = res.value;
                  }
                }
              }
            }
          }
        } else {
          a.Value = app.fields[a.NameID];
        }
      }
    }
  }
  return array;
};

export const runCondition = async (condition, value) => {
  if (condition.conditionType === "number") {
    switch (condition.type) {
      case "<":
        return value < condition.value ? true : false;
      case ">":
        return value > condition.value ? true : false;
      case "<=":
        return value <= condition.value ? true : false;
      case ">=":
        return value >= condition.value ? true : false;
      case "=":
        return value == condition.value ? true : false;
      case "!=":
        return value != condition.value ? true : false;
      default:
        return true;
    }
  }
  if (condition.conditionType === "length") {
    switch (condition.type) {
      case "<":
        return value.length < condition.value ? true : false;
      case ">":
        return value.length > condition.value ? true : false;
      case "<=":
        return value.length <= condition.value ? true : false;
      case ">=":
        return value.length >= condition.value ? true : false;
      case "=":
        return value.length == condition.value ? true : false;
      case "!=":
        return value.length != condition.value ? true : false;
      default:
        return true;
    }
  }
  if (condition.conditionType === "string") {
    switch (condition.type) {
      case "=":
        return value == condition.value ? true : false;
      case "!=":
        return value != condition.value ? true : false;
      default:
        return true;
    }
  }
  if (condition.conditionType === "required") {
    switch (condition.type) {
      case "=":
        return value == condition.value ? true : false;
      case "!=":
        return value != condition.value ? true : false;
      default:
        return true;
    }
  }
};
// ----------------------------------------------------------------------
